export function StepBadge({ number }: { number: number }) {
  return (
    <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-zinc-900 text-sm font-bold text-white dark:bg-white dark:text-slate-900">
      {number}
    </span>
  )
}

export function StepTitle({
  number,
  title,
}: {
  number: number
  title: string
}) {
  return (
    <span className="mb-4 flex items-center gap-3 text-xl text-slate-900 dark:text-white">
      <StepBadge number={number} />
      {title}
    </span>
  )
}
